export default __webpack_public_path__ + "static/media/about4.92c6c113.png";